import * as React from 'react'
import { Theme, useTheme } from '@mui/material/styles'
import { FC } from 'react'
import { ISalesFunnelSummaryCard } from '@user/store/salesFunnelSummary/typings'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { SalesFunnelMetric } from '../SalesFunnelMetric'
import Card from '@mui/material/Card'
import { InfoIcon, LightTooltip } from '@sales-center/components'

const getStyles = (theme: Theme) => ({
  card: {
    padding: theme.spacing(0.2),
    minWidth: '382px',
    minHeight: '148px',
    lineHeight: '21px',
  },

  summaryText: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },

  root: {
    backgroundColor: theme.palette.common.white,
    width: '100%',
  },

  title: {
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: '28px',
  },

  infoTooltip: {
    marginLeft: theme.spacing(0.5),
  },
})

interface Props {
  summaryCard: ISalesFunnelSummaryCard
}
export const SalesFunnelSummaryCard: FC<Props> = (props) => {
  const { summaryCard } = props
  const { avgTimeToClose, closedWonConversionRate } = summaryCard
  const styles = getStyles(useTheme())
  return (
    <Card elevation={2} sx={styles.card}>
      <Box p={2} sx={styles.root} flexShrink={0}>
        <Grid container direction="column">
          <Grid item>
            <Box flexShrink={0}>
              <Grid container>
                <Grid item>
                  <SalesFunnelMetric
                    count={summaryCard.salesFunnelsCount}
                    title="Sales Funnels"
                    variant="h1"
                  />
                </Grid>
                <Grid item>
                  <Box sx={styles.summaryText}>
                    <Box display="flex" alignItems="center" gap={0.2}>
                      <Typography component="div">
                        Average Time to Close: <b>{avgTimeToClose} days</b>{' '}
                      </Typography>
                      <LightTooltip
                        title={`Measures sales process efficiency to close sales for the selected date range. Average is calculated using closed/won date and includes leads / opportunities that were created outside the selected date range that were closed/won within the range.`}
                      >
                        <Box
                          width="15px"
                          height="15px"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <InfoIcon height="12px" width="12px" />
                        </Box>
                      </LightTooltip>
                    </Box>
                    <Box display="flex" alignItems="center" gap={0.2}>
                      <Typography>
                        Closed/Won Conversion Rate:{' '}
                        <b>{closedWonConversionRate}%</b>{' '}
                      </Typography>
                      <LightTooltip
                        title={`Measures sales success rate for the selected date range. Calculated by comparing the won opportunities in the date range against the total leads and opportunities disqualified, lost, or won within the date range.`}
                      >
                        <Box
                          width="15px"
                          height="15px"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <InfoIcon height="12px" width="12px" />
                        </Box>
                      </LightTooltip>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Card>
  )
}

SalesFunnelSummaryCard.displayName = 'SalesFunnelSummaryCard'
